// loading.js
export default function initLoading() {
  return new Promise((resolve) => {
    const cookieName = 'visited';
    const cookieHours = 24; // 有効期間（時間）
    const body = document.body;

    const setCookie = (name, value, hours) => {
      const date = new Date();
      date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
      const expires = "expires=" + date.toUTCString();
      document.cookie = `${name}=${value};${expires};path=/`;
    };

    const getCookie = (name) => {
      const nameEQ = name + "=";
      const ca = document.cookie.split(';');
      for (let c of ca) {
        c = c.trim();
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
      }
      return "";
    };

    const visitedCookie = getCookie(cookieName);

    // Cookieがある場合は即ロード済みにしてresolve
    if (visitedCookie) {
      body.classList.add('js-is-loaded');
      resolve();
      return;
    }

    // 初回アクセス時
    body.classList.add('js-is-loading');

    const hideLoadingScreen = () => {
      body.classList.remove('js-is-loading');
      body.classList.add('js-is-loaded');
      setCookie(cookieName, 'true', cookieHours);
      resolve(); // ✅ ローディング完了後にresolve
    };

    const minDurationPromise = new Promise(res => setTimeout(res, 3800)); // 最低5秒
    const pageLoadPromise = new Promise(res => {
      if (document.readyState === 'complete') {
        res();
      } else {
        window.addEventListener('load', res, { once: true });
      }
    });

    Promise.all([minDurationPromise, pageLoadPromise]).then(hideLoadingScreen);
  });
}
